import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '@environments/environment';
import { BuildInfo } from './build-info.model';

@Injectable({
    providedIn: 'root',
})
export class BuildInfoStore {
    private http = new HttpClient(inject(HttpBackend));
    private buildInfo: BuildInfo = {};

    async load(): Promise<void> {
        if (!environment.production) {
            this.buildInfo = {};
            return;
        }

        try {
            this.buildInfo = await firstValueFrom(this.http.get<BuildInfo>('./version.json'));
        } catch {
            this.buildInfo = {};
        }
    }

    get snapshot(): BuildInfo {
        return this.buildInfo;
    }
}
